import i18n from ".";
import { SECTION_NAMES, SectionKey, VIEW_NAMES, ViewKey } from "../utilities/helpers/pageVocabulary.generated";

export const viewName = (view: ViewKey) => i18n.t(`views.${view}`, { ns: "nav", defaultValue: VIEW_NAMES[view] });

export const sectionName = (section: SectionKey) =>
  i18n.t(`sections.${section}`, { ns: "nav", defaultValue: SECTION_NAMES[section] });

const NAV_GROUPS = ["Telemetry", "Blasts", "References", "Targets"] as const;

const isNavGroup = (label: string): label is (typeof NAV_GROUPS)[number] => (NAV_GROUPS as readonly string[]).includes(label);

export const routeLabel = (label: string) => (isNavGroup(label) ? i18n.t(`navGroups.${label}`) : label);

const ROLES = ["Spectator", "User", "Admin", "Lead Admin", "Super Admin"] as const;

const isRole = (name: string): name is (typeof ROLES)[number] => (ROLES as readonly string[]).includes(name);

export const roleLabel = (name: string) => (isRole(name) ? i18n.t(`roles.${name}`) : name);
